import {
  Box,
  Dialog,
  DialogHeader,
  DialogPopup,
  DialogTitle,
  Video,
} from "@salestrak/ui";
import { useMediaStreamUrl } from "#app/lib/hooks/use-note-media";
import type { Omittable } from "@salestrak/ui";

/**
 * Inline video player. Streams from a presigned URL (range requests, not a
 * wholesale blob download) so large clips seek without downloading everything.
 * The URL mints only while the dialog is open.
 */
export function MediaVideoDialog({
  photoId,
  fileName,
  open,
  onOpenChange,
}: Omittable<{
  photoId: string;
  fileName?: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}>) {
  const streamUrl = useMediaStreamUrl(open ? photoId : null);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPopup size="4xl">
        <DialogHeader>
          <DialogTitle>{fileName ?? "Video"}</DialogTitle>
        </DialogHeader>
        <Box paddingX="lg" paddingBottom="lg">
          <Box
            fill="width"
            height={480}
            surface="sunken"
            rounded="md"
            overflow="hidden"
          >
            {streamUrl ? (
              <Video
                src={streamUrl}
                fill
                autoPlay
                aria-label={fileName ?? "Video"}
              />
            ) : null}
          </Box>
        </Box>
      </DialogPopup>
    </Dialog>
  );
}
